'use strict'

import React from 'react'
import PropTypes from 'prop-types'

class HelpLink extends React.Component {
  render () {
    const { children } = this.props

    return <a {...this.props}>{children}</a>
  }
}

HelpLink.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  href: PropTypes.string,
  'data-test': PropTypes.string
}

export default HelpLink
